export const isValidCountry = (value: string): value is ProductionCountry => {
  return ['US', 'UK'].includes(value);
};
